// Version : 0.0.1
// Author : VISHAL BHARATHI
// LastEdit : VISHAL BHARATHI
// Last ADD : GOLD CLOSE LOAN REDUCER CREATED
// MODIFIED DATE: 23-08-2025

/* eslint-disable import/no-anonymous-default-export */
import GoldCloseLoanActionTypes from './gold-close-loan.types';
import { docodeHexResponse } from '../../_common/common.utils';

const INITIAL_STATE = {
	// Gold Loan Member Details Response
	getGoldLoanMemberDetailsResponse: null,
	// Gold Loan Member Details Array
	getGoldLoanMemberDetailsArr: [],
	// Update Gold Close Details Response
	updateGoldCloseDetailsResponse: null,
	// Update Gold Close Details Array
	updateGoldCloseDetailsArr: [],
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** GET GOLD LOAN MEMBER DETAILS START *********************** */
		case GoldCloseLoanActionTypes.GET_GOLD_LOAN_MEMBER_DETAILS_SUCCESS:
			return {
				...state,
				getGoldLoanMemberDetailsResponse: action.payload,
				// Get Gold Loan Member Details Array
				getGoldLoanMemberDetailsArr: docodeHexResponse(
					action.payload,
					'GetGoldLoanMemberDetailsKey',
				),
			};

		case GoldCloseLoanActionTypes.GET_GOLD_LOAN_MEMBER_DETAILS_FAILURE:
			return {
				...state,
				getGoldLoanMemberDetailsResponse: action.payload,
				getGoldLoanMemberDetailsArr: [],
			};

		case GoldCloseLoanActionTypes.GET_GOLD_LOAN_MEMBER_DETAILS_RESPONSE_CHANGED:
			return { ...state, getGoldLoanMemberDetailsResponse: null };

		/** ***************** GET GOLD LOAN MEMBER DETAILS END *********************** */

		/** ***************** UPDATE GOLD CLOSE DETAILS START *********************** */
		case GoldCloseLoanActionTypes.UPDATE_GOLD_CLOSE_DETAILS_SUCCESS:
			return {
				...state,
				updateGoldCloseDetailsResponse: action.payload,
				// Update Gold Close Details Array
				updateGoldCloseDetailsArr: docodeHexResponse(
					action.payload,
					'UpdateGoldCloseDetailsKey',
				),
			};

		case GoldCloseLoanActionTypes.UPDATE_GOLD_CLOSE_DETAILS_FAILURE:
			return { ...state, updateGoldCloseDetailsResponse: action.payload };

		case GoldCloseLoanActionTypes.UPDATE_GOLD_CLOSE_DETAILS_RESPONSE_CHANGED:
			return {
				...state,
				updateGoldCloseDetailsResponse: null,
				updateGoldCloseDetailsArr: [],
			};

		/** ***************** UPDATE GOLD CLOSE DETAILS END *********************** */

		default:
			return state;
	}
};
